// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5UXOD3tgT6D0Ti05rb5w {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    gap: 8px;
}

.Jsoao76uWP7hWBQ3DZLX {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
}

.Oqq2KS6PxmGDr22EIKfg {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: 8px;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Footer/MobileFooter/MobileFooter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;AAC3B","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 16px;\n    gap: 8px;\n}\n\n.logoContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n}\n\n.linksContainer {\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    gap: 8px;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_5UXOD3tgT6D0Ti05rb5w`,
	"logoContainer": `Jsoao76uWP7hWBQ3DZLX`,
	"linksContainer": `Oqq2KS6PxmGDr22EIKfg`
};
export default ___CSS_LOADER_EXPORT___;
